import { Button, Grid, TextField } from '@material-ui/core'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'
import { IUser, IUserRegisterRequest } from '../../../../../models/user/IUser'
import "./FormNewUser.css"
import { useI18n } from 'utils/i18n/hooks/useI18n'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

interface FormNewUserProps {
    smsValidationId: string,
    onSubmit: (values: IUserRegisterRequest) => void,
    defaultValues?: IUser,
}
export const FormNewUser: FC<FormNewUserProps> = ({ smsValidationId, onSubmit, defaultValues }) => {
    const { t } = useI18n();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const onsubmit = async (newUser: IUser) => {
        const recaptchaToken = executeRecaptcha ? await executeRecaptcha('signup') : '';

        const userToRegister: IUserRegisterRequest = {
            name: newUser.name,
            email: newUser.email,
            phoneNumber: newUser.phoneNumber,
            ddd: newUser.ddd,
            cpf: newUser.cpf,
            smsValidationId: smsValidationId,
            recaptchaToken,
        }
        onSubmit(userToRegister);
    }

    return (
        <Formik
            initialValues={defaultValues ?? {} as IUser}
            onSubmit={onsubmit}
        >{
                ({
                    handleSubmit,
                    handleChange,
                    values,
                    isValid,
                    errors,
                    touched
                }) =>
                    <Form onSubmit={handleSubmit}>
                        {
                            <Grid container spacing={2}>

                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        value={values.ddd}
                                        name="ddd"
                                        label={t("auth.register.ddd")}
                                    />
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        value={values.phoneNumber}
                                        name="phoneNumber"
                                        label={t("auth.register.phone")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        value={values.cpf}

                                        name="cpf"
                                        label={t("auth.register.cpf")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        value={values.name}
                                        onChange={handleChange}
                                        name="name"
                                        label={t("auth.register.name")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        value={values.email}
                                        onChange={handleChange}
                                        name="email"
                                        label={t("auth.register.email")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth size="large"
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t("auth.register.register")}
                                        </Button>
                                </Grid>

                            </Grid>
                        }
                    </Form>

            }
        </Formik>
    )
}
